import {NotificationDisplayType, SalesChannelNotificationStatusesConfig} from '../models/notification';
import {SessionStatusCode} from '../enums/session-status-code.enum';
import {SalesChannel} from '../consts/sales-channel.enum';
import {ApplicationContextService} from '../services/impl/configuration/application-context.service';

export class NotificationStatusesConfig {

    private contextService: ApplicationContextService;

    constructor(contextService: ApplicationContextService) {
        this.contextService = contextService;
    }

    createStatusesConfig(): SalesChannelNotificationStatusesConfig[] {
        return [
            {
                salesChannel: SalesChannel.KIOSKPOLIS,
                default: true,
                statuses: [
                    {
                        codes: [
                            SessionStatusCode.PROCESS_COMPLETED
                        ],
                        status: 200,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.SUCCESS.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.SUCCESS.DESCRIPTION'
                        ],
                        imageSrc: './assets/images/notifications/notification-success.svg',
                        bannerVisible: false,
                        productsVisible: true,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: true,
                        headerConfig: {
                            submitGoogleReviewButtonVisible: true,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'process-completed'
                    },
                    {
                        codes: [
                            SessionStatusCode.PAYMENT_CANCELED
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.PAYMENT_ERROR.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_2',
                        ],
                        imageSrc: './assets/images/notifications/notification-payment-error.svg',
                        imageSrcMobile: './assets/images/notifications/notification-payment-error-mobile.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: 'NEXT_NOTIFICATION.PAYMENT_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'payment-canceled'
                    },
                    {
                        codes: [
                            SessionStatusCode.REGISTER_POLICY_ERROR,
                            SessionStatusCode.WAITING_TO_GET_PDF,
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_2',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_3'
                        ],
                        imageSrc: './assets/images/notifications/notification-register-policy-error.svg',
                        imageSrcMobile: './assets/images/notifications/notification-register-policy-error-mobile.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: this.contextService.isAgentContext ? null : 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'register-policy-error'
                    }
                ]
            },
            {
                salesChannel: SalesChannel.CARONE,
                statuses: [
                    {
                        codes: [
                            SessionStatusCode.PROCESS_COMPLETED
                        ],
                        status: 200,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.SUCCESS.CARONE_TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.SUCCESS.DESCRIPTION'
                        ],
                        imageSrc: './assets/images/notifications/notification-success-carone.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: true,
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'process-completed'
                    },
                    {
                        codes: [
                            SessionStatusCode.PAYMENT_CANCELED
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.PAYMENT_ERROR.CARONE_TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_2',
                        ],
                        imageSrc: './assets/images/notifications/notification-error-carone.svg',
                        imageSrcMobile: './assets/images/notifications/notification-error-carone.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: 'NEXT_NOTIFICATION.PAYMENT_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'payment-canceled'
                    },
                    {
                        codes: [
                            SessionStatusCode.REGISTER_POLICY_ERROR,
                            SessionStatusCode.WAITING_TO_GET_PDF,
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.CARONE_TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_2',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_3'
                        ],
                        imageSrc: './assets/images/notifications/notification-error-carone.svg',
                        imageSrcMobile: './assets/images/notifications/notification-error-carone.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: this.contextService.isAgentContext ? null : 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'register-policy-error'
                    }
                ]
            },
            {
                salesChannel: SalesChannel.NESTBANK,
                statuses: [
                    {
                        codes: [
                            SessionStatusCode.PROCESS_COMPLETED
                        ],
                        status: 200,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.SUCCESS.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.SUCCESS.DESCRIPTION'
                        ],
                        imageSrc: './assets/images/notifications/notification-success-nestbank.svg',
                        bannerVisible: false,
                        productsVisible: true,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: true,
                        headerConfig: {
                            submitGoogleReviewButtonVisible: true,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'process-completed'
                    },
                    {
                        codes: [
                            SessionStatusCode.PAYMENT_CANCELED
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.PAYMENT_ERROR.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.PAYMENT_ERROR.DESCRIPTION_2',
                        ],
                        imageSrc: './assets/images/notifications/notification-error-nestbank.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: 'NEXT_NOTIFICATION.PAYMENT_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'payment-canceled'
                    },
                    {
                        codes: [
                            SessionStatusCode.REGISTER_POLICY_ERROR,
                            SessionStatusCode.WAITING_TO_GET_PDF,
                        ],
                        status: 402,
                        type: NotificationDisplayType.STATIC,
                        title: 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.TITLE',
                        descriptions: [
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_1',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_2',
                            'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.DESCRIPTION_3'
                        ],
                        imageSrc: './assets/images/notifications/notification-error-nestbank.svg',
                        bannerVisible: false,
                        productsVisible: false,
                        footerVisible: true,
                        footerFeaturedProductsAllowed: false,
                        buttonLabel: this.contextService.isAgentContext ? null : 'NEXT_NOTIFICATION.REGISTER_POLICY_ERROR.BUTTON_LABEL',
                        headerConfig: {
                            submitGoogleReviewButtonVisible: false,
                            titleVisible: false,
                            navigationVisible: false
                        },
                        cssClassSuffix: 'register-policy-error'
                    }
                ]
            }
        ];
    }
}
